import {
  OpportunityInvitationResponseInterested,
  OpportunityInvitationResponseNotInterested,
} from '../../../../../lib/model/OpportunityInvitation';

class OpportunityDisplayBox {
  constructor(
    APIService,
    TaskQueueService,
    StaffUserService,
    LogService,
    DateTimeService,
    opportunityDetailsModal,
    filesModal,
    DEBUG
  ) {
    "ngInject";
    this.APIService = APIService;
    this.TaskQueueService = TaskQueueService;
    this.StaffUserService = StaffUserService;
    this.LogService = LogService;
    this.DateTimeService = DateTimeService;
    this.opportunityDetailsModal = opportunityDetailsModal;
    this.filesModal = filesModal;
    this.DEBUG = DEBUG;
    this._isLoading = false;
    this.LogService.debug(`OpportunityDisplayBox filsModal:`, filesModal);
  }

  set isOnline(val) {
    this._isOnline = val;
  }

  get isOnline() {
    if (this.APIService) {
      return this.APIService.isOnline;
    }
    return false;
  }

  get debug() {
    return this.DEBUG;
  }

  set opportunity(opportunity) {
    this._opportunity = opportunity;
  }

  get opportunity() {
    return this._opportunity;
  }

  get allowRespondYes() {
    return this.opportunity && this.opportunity.allowRespondYes;
  }

  get allowRespondNo() {
    return this.opportunity && this.opportunity.allowRespondNo;
  }

  get respondButtonsEnabled() {
    return this.isOnline && !this._isLoading;
  }

  get startDate() {
    return this.opportunity && this.opportunity.opportunities_start_date;
  }

  get endDate() {
    return this.opportunity && this.opportunity.opportunities_end_date;
  }

  get subject() {
    return this.opportunity && this.opportunity.opportunity_invitation_templates_subject;
  }

  get body() {
    return this.opportunity && this.opportunity.opportunity_invitation_templates_body;
  }

  get isLoading() {
    return this._isLoading;
  }

  get hasAttachments() {
    return this.opportunity && this.opportunity.documents && this.opportunity.documents.length > 0;
  }

  get attachmentDownloadEnabled() {
    return this.hasAttachments && this.APIService.isOnline;
  }

  showDetails() {
    return this.opportunityDetailsModal({
      opportunity: this.opportunity,
      staffUser: this.staffUser,
    })
  }

  showAttachments() {
    return this.filesModal({
      documents: this.opportunity.documents,
    })
  }

  respondYes() {
    return this._sendResponse(OpportunityInvitationResponseInterested);
  }

  respondNo() {
    return this._sendResponse(OpportunityInvitationResponseNotInterested);
  }

  _sendResponse(response) {
    const task = this.TaskQueueService.createTask('OpportunityInvitationResponseTask');
    task.staffUserId = this.opportunity.staffing_users_id;
    task.opportunityInvitationId = this.opportunity.id;
    task.response = response;
    if (task.canExecute) {
      this._isLoading = true;
      return task.execute()
        .catch(err => {
          this.LogService.warn(`OpportunityDisplayBox got error`, err);
          return this.$q.reject(err);
        })
        .then(result => {
          this.opportunity.response = response;
          return this.StaffUserService.refreshOpportunityInvitations(this.staffUser);
        })
        .finally(result => {
          this._isLoading = false;
          return result;
        })
    }
  }
}

export default OpportunityDisplayBox;

